import { ModalAdapter as Modal } from "./Modal";

export { Modal };
